export default "__VITE_ASSET__C1BL8q1K__"